import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { setToken } from "@/lib/auth-token";
import { useAuthStore } from "@/stores/auth-store";
import { useNavigate } from "react-router-dom";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const setMe = useAuthStore((s) => s.setMe);
  const navigate = useNavigate();

  async function ssoLogin() {
    setBusy(true); setError(null);
    try {
      const { data } = await api.get<{ url: string }>("/auth/login");
      window.location.href = data.url;
    } catch (err: any) {
      setError(err?.response?.data?.message ?? "SSO is not configured on this server yet.");
      setBusy(false);
    }
  }

  async function devLogin() {
    setBusy(true); setError(null);
    try {
      const { data } = await api.post<{ token: string; user: any }>("/auth/dev-login", { email });
      setToken(data.token);
      setMe({
        id: data.user.id,
        email: data.user.email,
        name: data.user.name,
        role: data.user.role,
        entity: data.user.entity,
      });
      navigate("/");
    } catch (err: any) {
      setError(err?.response?.data?.message ?? "Dev login unavailable in production.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle>CBC CRM</CardTitle>
          <CardDescription>Sign in with your cbcinc.ai account.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <Button className="w-full" onClick={ssoLogin} disabled={busy}>
            Continue with Microsoft (SSO)
          </Button>

          <div className="relative my-3 flex items-center gap-3 text-xs text-muted-foreground">
            <div className="h-px flex-1 bg-border" />
            dev
            <div className="h-px flex-1 bg-border" />
          </div>

          <Input
            type="email"
            placeholder="dev-login@cbcinc.ai (dev only)"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button variant="outline" className="w-full" onClick={devLogin} disabled={busy || !email}>
            Dev login (bootstrap first user)
          </Button>

          {error && <p className="text-sm text-destructive">{error}</p>}
        </CardContent>
      </Card>
    </div>
  );
}
